import { useMemo } from 'react';

import Matrix from './Matrix';
import { MATRIX_MAX_COLUMNS } from './MatrixHelper';

const matrixSourceFn = (pivot) => ({
    url: '/query/matrix',
    params: {
        type: 'test,agent',
        columnLimit: MATRIX_MAX_COLUMNS,
        entityFields: 'name,tags',
        metrics: pivot,
        pivot,
        renderAsEntity: true,
        sort: `-${pivot},-${pivot}`,
    },
    totalProperty: 'rowCount',
});

export default function QueryMatrix({ pivot, ...otherProps }) {
    const { matrixSource } = useMemo(() => ({ matrixSource: matrixSourceFn(pivot) }), [pivot]);

    return <Matrix dataSource={matrixSource} disableColumnRemover {...otherProps} />;
}
